import PropTypes from 'prop-types';

import classNames from 'classnames';

import Tooltip from '../Tooltip';
import InfoIcon from '../icons/InfoIcon';

import Link from '../Link';

import styles from './PaymentTimelineItem.module.scss';

const PaymentTimeLineItem = ({
  title,
  subtitle = null,
  value,
  valueWithoutOffer = null,
  tooltipText = null,
  onValueClick = null
}) => {
  const ValueContainer = onValueClick ? Link : 'div';
  const valueContainerProps = onValueClick
    ? {
        onClick: onValueClick
      }
    : {};

  const valueClasses = classNames('payment-timeline-item__value', {
    [styles['payment-timeline-item__value--with-offer']]: valueWithoutOffer
  });

  return (
    <div className={styles['payment-timeline-item']}>
      <div>
        <div className={styles['payment-timeline-item__title']}>
          {title}
          {tooltipText && (
            <Tooltip
              className={styles['payment-timeline-item__title-tooltip']}
              color="blue-indigo"
              position="bottom"
              tooltip={tooltipText}
            >
              <InfoIcon />
            </Tooltip>
          )}
        </div>
        {subtitle && <div>{subtitle}</div>}
      </div>
      {valueWithoutOffer && (
        <div className={styles['payment-timeline-item__value--without-offer']}>
          {valueWithoutOffer}
        </div>
      )}
      <ValueContainer {...valueContainerProps} className={valueClasses}>
        {value}
      </ValueContainer>
    </div>
  );
};

PaymentTimeLineItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.string.isRequired,
  valueWithoutOffer: PropTypes.string,
  tooltipText: PropTypes.string,
  onValueClick: PropTypes.func
};

export default PaymentTimeLineItem;
